/**
 * Firebase Emulator Suite endpoints (local development only).
 * Ports must match firebase.json → emulators.
 */

export const EMULATOR_HOST =
  import.meta.env.VITE_FIREBASE_EMULATOR_HOST?.trim() || '127.0.0.1';

/** @type {Record<string, number>} */
export const EMULATOR_PORTS = {
  auth:      Number(import.meta.env.VITE_FIREBASE_AUTH_EMULATOR_PORT      || 9099),
  firestore: Number(import.meta.env.VITE_FIREBASE_FIRESTORE_EMULATOR_PORT || 8080),
  functions: Number(import.meta.env.VITE_FIREBASE_FUNCTIONS_EMULATOR_PORT || 5001),
  storage:   Number(import.meta.env.VITE_FIREBASE_STORAGE_EMULATOR_PORT   || 9199),
  hosting:   Number(import.meta.env.VITE_FIREBASE_HOSTING_EMULATOR_PORT   || 5000),
  ui:        Number(import.meta.env.VITE_FIREBASE_UI_EMULATOR_PORT        || 4000),
};

export const FUNCTIONS_REGION =
  import.meta.env.VITE_FIREBASE_FUNCTIONS_REGION?.trim() || 'us-central1';
